import { useState } from 'react';
import { validateEmail, validateRequired } from '../utils/validation';
import type { ContactFormData } from '../types/contact';

const initialState: ContactFormData = {
  name: '',
  email: '',
  message: ''
};

export function useContactForm() {
  const [formData, setFormData] = useState<ContactFormData>(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const validateForm = () => {
    const nameError = validateRequired(formData.name, 'Le nom');
    if (nameError) return nameError;

    const emailError = validateEmail(formData.email);
    if (emailError) return emailError;

    const messageError = validateRequired(formData.message, 'Le message');
    if (messageError) return messageError;

    return null;
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError(null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      // API call would go here
      setSuccess(true);
      setFormData(initialState);
    } catch (err) {
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    formData,
    isSubmitting,
    error,
    success,
    handleChange,
    handleSubmit
  };
}